import styled from "@emotion/styled";
import { useEffect } from "react";

import { LatestUserTransactions } from "../../components/TransactionHistory/LatestUserTransactions";

export const LatestHistoryView = () => {
  // const { trackPageView } = useMatomo();
  // const { connected } = useEnrichedWallet();

  useEffect(() => {
    // trackPageView({
    //   documentTitle: "Transaction History",
    // });
  }, []);

  return (
    <>
      <LatestContainer>
        <LatestUserTransactions />
      </LatestContainer>
    </>
  );
};

const LatestContainer = styled.div`
  width: 100%;
  margin-top: 50px;
  .load-more-button-container {
    margin-top: 30px;
    .load-more-button {
      height: 60px;
      font-size: 16px;
    }
  }
`;
